import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { MINUTES_TO_MILLIS } from "lopermut"
import {
  BackofficeConversationExperimentKnowledgeAnalyticsResponseDataSchema,
  DataResponse,
  GetBackofficeConversationExperimentAnalyticsSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeConversationExperimentAnalyticsSchema>
type Response = DataResponse<
  z.infer<typeof BackofficeConversationExperimentKnowledgeAnalyticsResponseDataSchema>
>

const getBackofficeConversationExperimentKnowledgeAnalyticsQueryKey = (query: Query) => [
  "backofficeConversationExperimentKnowledgeAnalytics",
  query,
]

export const getBackofficeConversationExperimentKnowledgeAnalyticsQuery = ({
  query,
}: {
  query: Query
}) => {
  return queryOptions({
    queryKey: getBackofficeConversationExperimentKnowledgeAnalyticsQueryKey(query),
    staleTime: 5 * MINUTES_TO_MILLIS,
    retry: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    queryFn: async ({ signal }) => {
      const { data } = await axios.get<Response>("/backoffice/experiments/knowledge-analytics", {
        params: query,
        signal,
      })
      return data.data
    },
  })
}
